<header class="main__content__header modal-header">
  <h2 class="modal-title">Detalhes - {{details.provider}}</h2>
  <a class="header__btn__close" (click)="activeModal.close(true)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="main__content__modal modal-body">
  <section class="modal__main__dados_usuario content__modal__header">
    <div class="pl-0 pr-0 mb-3 row">
      <div class="col-sm-12 col-xl-6 mb-1">
        <span class="content__modal__title">Prestador</span>
        <p class="content__modal__valor">{{details.provider}}</p>
      </div>
      <div class="col-sm-12 col-xl-6 mb-1">
        <span class="content__modal__title">Profissional solicitante</span>
        <p class="content__modal__valor">{{details.doctor}}</p>
      </div>
      <div class="col-sm-12 col-xl-6">
        <span class="content__modal__title">Número da requisição</span>
        <p class="content__modal__valor">{{details.requestNumber}}</p>
      </div>
      <div class="col-sm-12 col-xl-6">
        <span class="content__modal__title">Data da solicitação</span>
        <p class="content__modal__valor">{{details.requestDate | date: 'dd/MM/yyyy'}}</p>
      </div>
      <div class="col-sm-12 col-xl-6">
        <span class="content__modal__title">Data de Validade</span>
        <p class="content__modal__valor">{{details.expirationDate | date: 'dd/MM/yyyy' | nullCheck: 'Não possui'}}</p>
      </div>
      <div class="col-sm-12 col-xl-6">
        <span class="content__modal__title">Situação</span>
        <p class="content__modal__valor">
          <status [status]="details.status"></status>
        </p>
      </div>
    </div>
  </section>
</main>
<footer>
  <section class="content__resultado__grid__main mb-2">
    <section class="content__header__table">
      <div class="col-2">Código</div>
      <div class="col-5">Procedimentos</div>
      <div class="col-2">Quantidade</div>
      <div class="col-3">Status</div>
    </section>
    <section class="content__main__table">
      <div class="table__card" *ngFor="let procedimento of  details.procedures">
        <div class="col-2">{{procedimento.code | nullCheck}}</div>
        <div class="col-5">{{procedimento.name | nullCheck}}</div>
        <div class="col-2">{{procedimento.amount | nullCheck}}</div>
        <div class="col-3">{{procedimento.status | nullCheck}}</div>
      </div>
    </section>
  </section>
</footer>